module.exports = __webpack_public_path__ + "static/mtsu-app-icon-18aa3cd7ce154207b9a7d8b5994529ed.png";